import { useContext, useEffect, useRef, useState } from "react";
import { CRS } from "./CRS";
import plz from 'url:../../../assets/cursors/PlasmaCursor.png';
import plzbg from 'url:../../../assets/cursors/plz.gif';
import CursorProvider from "../../../providers/CursorProvider";
import { useLocation } from "react-router";

export function PLZ ()
{
    const provider = useContext(CursorProvider.context);
    const [chrg, setChrg] = useState<boolean>();
    const locRef = useRef<string>('null');
    const loc = useLocation();

    useEffect(() => {
        setChrg(provider.plzchg);
    }, [provider.plzchg]);

    // useEffect(() => {
    //     const root_old = locRef.current.split('/')[1];
    //     const root_new = loc.pathname.split('/')[1];
    //     console.log(root_old + " > " + root_new + ", " + locRef.current + ", " + loc.pathname);
    //     if (root_old != root_new)
    //         setChrg(false);
    //     locRef.current = loc.pathname;
    // }, [loc]);

    return <CRS>
        { chrg ? <img src={plzbg} className='mcs-bg' /> : null }
        <img src={plz} className='mcs-icon' />
    </CRS>
}